import {
	Box,
	Button,
	Center,
	DrawerBody,
	DrawerContent,
	DrawerFooter,
	DrawerHeader,
	Badge,
	VStack,
	HStack,
	Grid,
	Flex,
	Spacer,
	Stack,
} from "@chakra-ui/react";

import { useState } from "react";

import { FaArrowLeft } from "react-icons/fa";
import { PotionDescription } from "./PotionDescription";
import { nameCleanup } from "../../../util/helpers";

import potions from "../../../util/alchemyInfo";
import { Raider } from "../../../types/raider";
import { EconomyTool } from "../../../pages/alchemy";

interface AlchemyDrawerProps {
	raider: Raider;
	tools: EconomyTool[];
	balances: Record<string, number>;
	updateTools: () => Promise<void>;
	closeDrawer: () => void;
}

export default function LeftDrawer(props: AlchemyDrawerProps) {
	const [raider] = useState<Raider>(props.raider);

	return (
		<DrawerContent>
			<DrawerHeader background="gray.900">
				<Flex>
					<HStack>
						<VStack align={{ base: "flex-start", md: "left" }}>
							<Box>{nameCleanup(raider.name)}</Box>
							<Badge variant="outline">lvl. {raider.attributes[1].value}</Badge>
						</VStack>
					</HStack>
					<Spacer />
					<Grid templateColumns="repeat(1, 1fr)" gap={6}>
						<Center width="4rem" height="4rem" transform="scale(0.5)" mb={6}>
							{/* Raider image here TK */}
						</Center>
					</Grid>
				</Flex>
			</DrawerHeader>

			<DrawerBody>
				<Stack spacing="6" py="2" px="2">
					{potions.map((potion) => {
						return (<PotionDescription
              key={potion.address}
				potion = {potion}
              raider={raider}
			tools={props.tools}
			balances={props.balances}
			updateTools={props.updateTools}
              />)})}
					
				</Stack>
			</DrawerBody>
			<DrawerFooter justifyContent="left">
				<Button
					leftIcon={<FaArrowLeft />}
					color="red.100"
					onClick={() => props.closeDrawer()}
				>
					I&#39;m not ready yet
				</Button>
			</DrawerFooter>
    </DrawerContent>
  )
}
